import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import { DialogTypes } from 'types/types';
import { useSetRecoilState } from 'recoil';
import { dialogState } from 'state';
import { Add } from '@mui/icons-material';
import useHasAccess from 'hooks/useHasAccess';
import { Permission } from 'state/permissionState';

export function ProjectSelectorBar() {
  const openDialog = useSetRecoilState(dialogState);
  const { t } = useTranslation();
  const canCreateProject = useHasAccess([Permission.SUPERADMIN]);

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      flexDirection="row"
      justifyContent="end"
    >
      <Button
        variant="contained"
        startIcon={<Add />}
        disabled={!canCreateProject}
        onClick={() =>
          openDialog({ isOpen: true, dialogType: DialogTypes.addProject })
        }
      >
        {t('projectSelector.addNewProject')}
      </Button>
    </Box>
  );
}
